// extracted by mini-css-extract-plugin
export default {"footer":"root_footer-module__footer___NTcQS","content":"root_footer-module__content___excsK","contentLanding":"root_footer-module__contentLanding___BdvL_"};